import { CommonModule, CurrencyPipe, DatePipe } from '@angular/common';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatTreeModule } from '@angular/material/tree';
import {
  BrowserModule
} from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule } from '@angular/router';
import { NgbDateParserFormatter, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectModule } from '@ng-select/ng-select';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { AuthStatePersistenceService, HttpErrorHandler, PageMetaResolver } from '@spartacus/core';
import { SmartEditModule } from '@spartacus/smartedit';
import { SmartEditLauncherService } from '@spartacus/smartedit/root';
import {
  AppRoutingModule,
  CmsPageGuard,
  PageLayoutComponent,
  ProductListComponentService
} from '@spartacus/storefront';
import { provideCharts, withDefaultRegisterables } from 'ng2-charts';
import { CustomSmartEditLauncherService } from 'src/custom-smart-edit-launcher.service';
import { LayoutConfigModule } from '../../src/features/layout/layout.module';
import { OrderHistoryModule } from '../app/order-history/order-history.module';
import { AccountOverviewModule } from './account-overview/account-overview.module';
import { AppComponent } from './app.component';
import { AsmResetPasswordModule } from './asm-reset-password/asm-reset-password.module';
import { AuthInterceptorService } from './auth-interceptor-service';
import { ChatbotModule } from './chatbot/chatbot.module';
import { CustomAddToCartModule } from './custom-add-to-cart/custom-add-to-cart.module';
import { CustomCollaborationModule } from './custom-collaboration/custom-collaboration/custom-collaboration.module';
import { CustomCustomerServiceBrModule } from './custom-customer-service-br/custom-customer-service-br.module';
import { CustomInfluenzaModule } from './custom-influenza/custom-influenza.module';
import { CustomPdpModule } from './custom-pdp/custom-pdp.module';
import { CustomProdListService } from './custom-prod-pg/custom-prod-list.service';
import { CustomProfileAndPreferencesModule } from './custom-profile-and-preferences/custom-profile-and-preferences.module';
import { EmailChangeTokenComponent } from './custom-profile-and-preferences/email-change-token/email-change-token.component';
import { ReturnModule } from './custom-return/return.module';
import { CustomUserRegistrationModule } from './custom-user-registration/custom-user-registration.module';
import { CustomerHierarchyModule } from './customer-hierarchy/customer-hierarchy.module';
import { FaqModule } from './faq/faq.module';
import { ForbiddenHandler } from './forbidden-handler';
import { ForgotUserPasswordModule } from './forgot-user-password/forgot-user-password.module';
import { HomeScreenModule } from './home-screen/home-screen/home-screen.module';
import { LoginRedirectModule } from './login-redirect/login-redirect/login-redirect.module';
import { LoginRedirectComponent } from './login-redirect/login-redirect/login-redirect/login-redirect.component';
import { MakeAPaymentModule } from './make-a-payment/make-a-payment.module';
import { MessgeHistoryModule } from './messge-history/messge-history.module';
import { MyAuthStatePersistenceService } from './my-auth-state-persistence-service.service';
import { MyOffersModule } from './my-offers/my-offers.module';
import { OspPageMetaResolver } from './osp-categories/meta-resolver/osp-page-meta.resolver';
import { OspSearchResultPageMetaResolver } from './osp-categories/meta-resolver/osp-search-result-page-meta.resolver';
import { OspCategoriesModule } from './osp-categories/osp-categories.module';
import { PaymentHistoryModule } from './payment-history/payment-history.module';
import { ReportsModule } from './reports/reports.module';
import { SanofiRulesModule } from './sanofi-rules/sanofi-rules.module';
import { SearchBoxModule } from './search-box/search-box.module';
import { AddCardModule } from './shared/modules/add-card/add-card.module';
import { CheckoutModule } from './shared/modules/checkout/checkout.module';
import { ConfirmProfilePopupModule } from './shared/modules/confirm-profile-popup/confirm-profile-popup.module';
import { ExternalsiteAlertModule } from './shared/modules/externalsite-alert/externalsite-alert.module';
import { FaxEmailPopupModule } from './shared/modules/fax-email-popup/fax-email-popup.module';
import { FutureCartModule } from './shared/modules/future-cart/future-cart.module';
import { GeneralPopupModule } from './shared/modules/general-popup/general-popup.module';
import { InfluenzaCartModule } from './shared/modules/influenza-cart/influenza-cart.module';
import { LocationStripModule } from './shared/modules/location-strip/location-strip.module';
import { MatNrModule } from './shared/modules/mat-nr/mat-nr.module';
import { OtpModalModule } from './shared/modules/otp-modal/otp-modal.module';
import { PaymentMethodModule } from './shared/modules/payment-method/payment-method.module';
import { PersonalizationBannerModule } from './shared/modules/personalization-banner/personalization-banner.module';
import { RestrictionPopupModule } from './shared/modules/restriction-popup/restriction-popup.module';
import { CustomModalService } from './shared/services/custom-modal.service';
import { CustomAdapter } from './shared/utils/customAdapter';
import { SpartacusModule } from './spartacus/spartacus.module';
import { StatementsModule } from './statements/statements.module';
import { StsAdminModule } from './sts-admin/sts-admin.module';
import { ToolsAndResourcesModule } from './tools-and-resources/tools-and-resources.module';
import { UnauthorizedForbiddenHandlerService } from './unauthorized-forbidden-handler.service';
import { UnauthorizedServiceService } from './unauthorized-service.service';
import { UnifyRedirectModule } from './unify-redirect/unify-redirect.module';
import { UnifyRedirectComponent } from './unify-redirect/unify-redirect/unify-redirect.component';
import { UserAccessManagementModule } from './user-access-management/user-access-management.module';
import { VaxAboutContactUsModule } from './vax-about-contact-us/vax-about-contact-us.module';
import { UserModalModule } from './custom-profile-and-preferences/user/user-modal/user-modal.module';
@NgModule({
  declarations: [AppComponent],
  imports: [
    SmartEditModule,
    BrowserModule.withServerTransition({ appId: 'serverApp' }),
    HttpClientModule,
    AsmResetPasswordModule,
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    AppRoutingModule,
    StoreModule.forRoot({}),
    EffectsModule.forRoot([]),
    SpartacusModule,
    LayoutConfigModule,
    CustomPdpModule,
    CustomInfluenzaModule,
    CustomUserRegistrationModule,
    CustomAddToCartModule,
    NgSelectModule,
    FormsModule,
    HomeScreenModule,
    ForgotUserPasswordModule,
    CustomProfileAndPreferencesModule,
    AddCardModule,
    CheckoutModule,
    ExternalsiteAlertModule,
    LocationStripModule,
    OrderHistoryModule,
    StatementsModule,
    SearchBoxModule,
    AccountOverviewModule,
    ReportsModule,
    FaqModule,
    ToolsAndResourcesModule,
    UserAccessManagementModule,
    CustomCollaborationModule,
    CustomCustomerServiceBrModule,
    MatInputModule,
    MatSnackBarModule,
    MessgeHistoryModule,
    ReturnModule,
    StsAdminModule,
    PersonalizationBannerModule,
    PaymentHistoryModule,
    SanofiRulesModule,
    FutureCartModule,
    MakeAPaymentModule,
    ConfirmProfilePopupModule,
    FaxEmailPopupModule,
    PaymentMethodModule,
    RestrictionPopupModule,
    LoginRedirectModule,
    GeneralPopupModule,
    InfluenzaCartModule,
    CustomerHierarchyModule,
    MatTreeModule,
    VaxAboutContactUsModule,
    MatProgressSpinnerModule,
    BrowserAnimationsModule,
    OspCategoriesModule,
    ChatbotModule,
    UnifyRedirectModule,
    MatNrModule,
    OtpModalModule,
    MyOffersModule,
    UserModalModule,
    RouterModule.forChild([
      {
        path: 'help-center',
        redirectTo: '/help-center/all',
        pathMatch: 'full',
      },
      {
        path: 'punchout/cxml/session',
        component: LoginRedirectComponent,
      },
      {
        path: 'success/cxml/session',
        component: UnifyRedirectComponent
      },
      {
        path: 'otp/update-email',
        component: EmailChangeTokenComponent,
      },

      {
        // path with a dynamic parameter:
        path: 'help-center/search',

        // page label without a parameter, starting with slash:
        data: { pageLabel: '/help-center/search' },

        // the following are needed to display slots and components from the CMS:
        component: PageLayoutComponent,
        canActivate: [CmsPageGuard],
      },
      {
        // path with a dynamic parameter:
        path: 'help-center/:contentCategoryCode',

        // page label without a parameter, starting with slash:
        data: { pageLabel: '/help-center' },

        // the following are needed to display slots and components from the CMS:
        component: PageLayoutComponent,
        canActivate: [CmsPageGuard],
      }
    ])],
  providers: [
    AppComponent,
    {
      provide: ProductListComponentService,
      useClass: CustomProdListService,
    },
    {
      provide: AuthStatePersistenceService,
      useClass: MyAuthStatePersistenceService,
    },
    {
      provide: HttpErrorHandler,
      useExisting: ForbiddenHandler,
      multi: true,
    },
    {
      provide: HttpErrorHandler,
      useExisting: UnauthorizedServiceService,
      multi: true,
    },
    {
      provide: HttpErrorHandler,
      useExisting: UnauthorizedForbiddenHandlerService,
      multi: true,

    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptorService,
      multi: true,
    },
    {
      provide: PageMetaResolver,
      useClass: OspPageMetaResolver,
      multi: true,
    },
    {
      provide: PageMetaResolver,
      useClass: OspSearchResultPageMetaResolver,
      multi: true,
    },
    {
      provide: NgbDateParserFormatter,
      useClass: CustomAdapter
    },
    {
      provide: Window,
      useValue: window
    },
    {
      provide: SmartEditLauncherService,
      useClass: CustomSmartEditLauncherService
    },
    { provide: NgbModal, useClass: CustomModalService },
    DatePipe,
    CurrencyPipe,
    provideCharts(withDefaultRegisterables())
  ],

  bootstrap: [AppComponent],
})
export class AppModule { }
